export const OFFICER_LIST_REQUEST = 'OFFICER_LIST_REQUEST';
export const OFFICER_LIST_REQUEST_SUCCESS = 'OFFICER_LIST_REQUEST_SUCCESS';
export const OFFICER_LIST_REQUEST_ERROR = 'OFFICER_LIST_REQUEST_ERROR';

export const OFFICER_ADD = 'OFFICER_ADD';
export const OFFICER_ADD_SUCCESS = 'OFFICER_ADD_SUCCESS';
export const OFFICER_ADD_ERROR = 'OFFICER_ADD_ERROR';

export const OFFICER_UPDATE = 'OFFICER_UPDATE';
export const OFFICER_UPDATE_SUCCESS = 'OFFICER_UPDATE_SUCCESS';
export const OFFICER_UPDATE_ERROR = 'OFFICER_UPDATE_ERROR';

export const OFFICER_REMOVE = 'OFFICER_REMOVE';
export const OFFICER_REMOVE_SUCCESS = 'OFFICER_REMOVE_SUCCESS';
export const OFFICER_REMOVE_ERROR = 'OFFICER_REMOVE_ERROR';

export const OFFICER_REQUEST = 'OFFICER_REQUEST';
export const OFFICER_REQUEST_SUCCESS = 'OFFICER_REQUEST_SUCCESS';
export const OFFICER_REQUEST_ERROR = 'OFFICER_REQUEST_ERROR';

export const OFFICER_PERFORMANCE_LIST_REQUEST = 'OFFICER_PERFORMANCE_LIST_REQUEST';
export const OFFICER_PERFORMANCE_LIST_REQUEST_SUCCESS = 'OFFICER_PERFORMANCE_LIST_REQUEST_SUCCESS';
export const OFFICER_PERFORMANCE_LIST_REQUEST_ERROR = 'OFFICER_PERFORMANCE_LIST_REQUEST_ERROR';
